export const rules_et = (
  <>
    <p>
      <strong>Lisaloosi reeglid:</strong>
    </p>
    <ol>
<li>“Vikinglotto lisaloos 2023" (edaspidi lisaloos) viiakse läbi 01.11.2023 kuni 31.12.2023 ostetud Vikinglotto mängukombinatsioonide vahel. </li>
<li>Lisaloosi korraldajaks on AS Eesti Loto (asukoht: Hallivanamehe 4, 11317 Tallinn, registrikood 10281170; edaspidi Eesti Loto).</li>
<li>Lisaloosi läbiviimine on reguleeritud käesolevate reeglitega ja lisaloosi võidu vastuvõtmisega kinnitab mängija nõustumist lisaloosi reeglitega. </li>
<li>Lisaloosimine ja selle salvestus toimub 04.01.2024 telestuudios aadressil Tallinn, Peterburi tee 81. </li>
<li>Iga lisaloosis osaleva pileti mängukombinatsioon annab pileti omanikule võiduvõimalusi vastavalt sellele, mitmes Vikinglotto põhiloosimises see mängukombinatsioon osaleb. Näiteks: kaheks loosimiseks ostetud viie mängukombinatsiooniga pilet osaleb lisaloosis kümne võiduvõimalusega. </li>
<li>Lisaloosi võidud loositakse välja elektroonilise juhuarvugeneraatori (random number generator) abil.   Loosimise järel avalikustatakse väljaloositud pileti number. </li>
<li>Loosimise salvestusel osalevad 40 mängijat, kes loositakse välja kõigi salvestusel osalemiseks registreerunud mängijate hulgast. </li>
<li>Salvestusel osaleda soovijatel tuleb osta Vikinglotto pilet ajavahemikul 01.11.–17.12.2023 ja registreeruda e-posti teel <a className="clickableText clickableText--primary" href="mailto:klienditugi@eestiloto.ee">klienditugi@eestiloto.ee</a> või Eesti Loto klienditeeninduse telefonil 650 2030. Registreerumisel tuleb esitada pileti number, isikukood, nimi ja kontaktandmed. Registreeruda tuleb hiljemalt 17.12.2023. </li>
<li>Lisaloosi salvestusel osalejate loosimine viiakse läbi 18.12.2023 elektroonselt, kasutades juhuarvugeneraatorit. Eesti Loto võtab väljaloositud mängijatega ühendust kolme päeva jooksul peale loosimist. Juhul, kui Eesti Loto ei saa mängijaga selle aja jooksul ühendust, kaotab mängija õiguse salvestusel osaleda ja tema asemel saab osalemisvõimaluse järgmine väljaloositud mängija. </li>
<li>Lisaloosi salvestusel osalevate mängijate võidusumma (5000 €) loosimine viiakse läbi kasutades loosisedeleid. </li>
<li>Lisaloosi võidufond on 183 000 eurot. Võitude struktuur on järgmine: 
<br />2 x 52 000 eurot* 
<br />5 x 10 000 eurot
<br />5 x 5000 eurot, millest üks võit loositakse stuudios salvestusel osalevate mängijate vahel
<br />40 x 100 eurot (salvestusel osalejatele)
<br />*Peavõidu võitja võib soovi korral oma rahalise võidu võtta välja sõiduautona Volkswagen ID.4.</li>
<li>Lisaloosis ei saa osaleda Eesti Loto töötajad (v.a lapsehoolduspuhkusel olevad isikud), Eesti Loto nõukogu liikmed ja loosimiste järelevalve töötajad. </li>
<li>Lisaloosis ei või osaleda nooremad kui 16-aastased isikud.</li>
<li>Lisaloosi tulemused avalikustatakse TV3-s eetris olevas Vikinglotto Aastaloosi telesaates 07.01.2024. </li>
<li>Kõigi lisaloosi võitjatega võtab Eesti Loto ühendust hiljemalt 5 tööpäeva jooksul pärast lisaloosimise tulemuste avalikustamist. Võitnud piletinumbrite kohta saab informatsiooni telesaatest, alates 08.01.2024 Eesti Loto telefonil 650 2030 ja koduleheküljelt <a className="clickableText clickableText--primary" href="https://www.eestiloto.ee">www.eestiloto.ee</a>. </li>
<li>Mängijad võtavad endale vastutuse Eesti Loto infosüsteemis registreeritud isikuandmete õigsuse ja korrektsuse eest. Mängija poolt valede või ebakorrektsete andmete esitamisel ei taga Eesti Loto mängijale võidust teavitamist ega temale võidu väljamaksmist. </li>
<li>Lisaloosi võidud vormistatakse Eesti Loto kontoris (Hallivanamehe 4, Tallinn) või salvestuse ajal telestuudios, aadressil Tallinn, Peterburi tee 81. Võidu vormistamiseks tuleb võidupileti omanikul esitada oma isikut tõendav dokument. Võite saab vormistada ka elektroonselt, saates digiallkirjastatud “Võiduavalduse” Eesti Loto e-posti aadressile <a className="clickableText clickableText--primary" href="mailto:lotopost@eestiloto.ee">lotopost@eestiloto.ee</a>. Avaldus koos juhisega võidu vormistamiseks asub Eesti Loto kodulehel. </li>
<li>Võitude vormistamise lõpptähtaeg on 15.02.2024.</li>
<li>Rahaliste võitude väljamaksmise lõpptähtaeg on 15.03.2024, auto üleandmise tähtaeg vastavalt võidu vormistamise hetkel Moller Auto Tallinn OÜ poolt pakutavale auto tarnimise kuupäevale.</li>
<li>Loosimistest osavõtu ja võidu kättesaamisega seotud kulutusi mängijatele ei kompenseerita. </li>
<li>Vääramatu jõu (<i>force majeure</i>) ilmnemisel on Eesti Lotol ühepoolne õigus katkestada lisaloos ja jätta võidud välja loosimata ja/või üle andmata, teatades sellest koheselt meedia vahendusel.</li>
<li>Kõik lisaloosiga seotud vaidlused lahendatakse vastavalt Eesti Vabariigis kehtivale seadusandlusele. Kõik pretensioonid seoses lisaloosi korraldamise ja/või läbiviimisega tuleb saata kirjalikult Eesti Loto aadressil (vt p. 2) hiljemalt 19.01.2024. Pretensiooni lahendamise tähtaeg on 2 nädalat arvates pretensiooni laekumisest. Anonüümseid pretensioone ja avaldusi läbi ei vaadata ning neile ei vastata.</li>

    </ol>
  </>
);

export const rules_ru = (
  <>
    <p>
      <strong> Правила дополнительного розыгрыша:</strong>
    </p>
   
    <ol>
<li>“Дополнительный розыгрыш Vikinglotto 2023" (далее – дополнительный розыгрыш) проводится среди игровых комбинаций Vikinglotto, купленных с 01.11.2023 по 31.12.2023. </li>
<li>Учредителем дополнительного розыгрыша является AS Eesti Loto (адрес: Халливанамехе 4, 11317 Таллинн, регистрационный код 10281170; далее - Eesti Loto).</li>
<li>Порядок проведения дополнительного розыгрыша установлен настоящими правилами.  <br />Принимая выигрыш, разыгранный в ходе дополнительного розыгрыша, игрок подтверждает свое согласие с правилами дополнительного розыгрыша.</li>
<li>Дополнительный розыгрыш и запись будут проведены 04.01.2024 в телестудии по адресу Таллинн, Петербури теэ 81. </li>
<li>Каждая игровая комбинация билета, участвующего в дополнительном розыгрыше, дает владельцу билета столько выигрышных возможностей, в скольких розыгрышах Vikinglotto участвует данная игровая комбинация; Например: билет с пятью игровыми комбинациями, купленный на два розыгрыша, участвует в дополнительном розыгрыше с десятью выигрышными возможностями. </li>
<li>Выигрыши дополнительного розыгрыша разыгрываются с помощью генератора случайных чисел (random number generator). По результатам розыгрыша обнародуется номер выигрышного билета.</li>
<li>В записи розыгрыша примут участие 40 игроков, которые будут выбраны путём розыгрыша из числа всех игроков, зарегистрированных для участия в записи. </li>
<li>Желающим принять участие в записи нужно купить билет Vikinglotto в период 01.11.–17.12.2023 и зарегистрироваться по эл.адресу <a className="clickableText clickableText--primary" href="mailto:klienditugi@eestiloto.ee" target="_blank" rel="noreferrer">klienditugi@eestiloto.ee</a> или по телефону службы поддержки клиентов Eesti Loto 650 2030. Во время регистрации нужно предоставить номер билета, личный код, имя и контактные данные. Зарегистрироваться нужно не позднее 17.12.2023. </li>
<li>Розыгрыш участников в записи дополнительного розыгрыша проводится 18.12.2023 электронным путём при помощи генератора случайных чисел. Eesti Loto связывается со всеми победителями в течение трех рабочих дней после розыгрыша. В случае, если Eesti Loto не сумеет связаться с победителем в течение этого времени, то этот игрок потеряет право участвовать в записи и вместо него возможность принять участие в записи получит следующий игрок тоже путём розыгрыша. </li>
<li>Розыгрыш выигрыша (5000 €) участников записи дополнительного розыгрыша проводится с использованием бумажных жетонов. </li>
<li>Призовой фонд дополнительного розыгрыша 183 000 евро. Выигрыши имеют следующую структуру:
<br />2 x 52 000 евро*
<br />5 x 10 000 евро
<br />5 x 5000 евро, один из выигрышей разыгрываются в студии среди участвующих в записи игроков 
<br />40 x 100 евро (участникам записи)
<br />*Игрок, выигравший главный выигрыш, может по желанию получить свой денежный выигрыш в виде автомобиля Volkswagen ID.4. 
</li>
<li>Лица, связанные с проведением дополнительного розыгрыша, в том числе, работники Eesti Loto (кроме находящихся в отпуске по уходу за ребёнком), члены совета Eesti Loto и лица, осуществляющие надзор, не могут участвовать в дополнительном розыгрыше. </li>
<li>В дополнительном розыгрыше не могут участвовать лица моложе 16 лет.</li>
<li>Результаты дополнительного розыгрыша будут опубликованы в телепередаче «Vikinglotto - Розыгрыш Года» в эфире TV3 07.01.2024. </li>
<li>Eesti Loto связывается со всеми победителями не позднее чем в течение пяти рабочих дней после обнародования результатов дополнительного розыгрыша. Информацию о номерах выигравших билетов можно получить из телепередачи, с 08.01.2024 из Eesti Loto по телефону 650 2030 и на сайте <a className="clickableText clickableText--primary" href="https://www.eestiloto.ee/ru/" target="_blank" rel="noreferrer">www.eestiloto.ee</a>. </li>
<li>Игроки берут на себя ответственность за правильность и корректность личных данных, зарегистрированных в инфосистеме Eesti Loto. При предоставлении игроком ложных или некорректных данных Eesti Loto не обеспечивает игрока информацией о выигрыше и самим выигрышем. </li>
<li>Выигрыши дополнительного розыгрыша можно оформить в офисе Eesti Loto (Халливанамехе 4, Таллинн) или в во время записи в телестудии по адресу Петербури теэ, Таллинн. Для оформления выигрыша владелец выигрышного билета должен предъявить удостоверение личности. Выигрыши также можно оформить электронным путем, отправив дигитально подписанное Заявление о выплате выигрыша на э-почту Eesti Loto по адресу <a className="clickableText clickableText--primary" href="mailto:lotopost@eestiloto.ee" >lotopost@eestiloto.ee</a>. Форма заявления вместе с инструкцией по оформлению выигрыша находится на веб-сайте Eesti Loto.</li>
<li>Последний день оформления выигрышей 15.02.2024.</li>
<li>Последний день выплаты денежных выигрышей 15.03.2024, срок передачи автомобиля в соответствии c предоставленной представительством Moller Auto Tallinn OÜ на момент оформления выигрыша датой поставки предлагаемого автомобиля. </li>
<li>Затраты, связанные с участием в розыгрышах и получением выигрыша, игрокам не компенсируются. </li>
<li>В случае непреодолимых обстоятельств (<i>force majeure</i>) Eesti Loto вправе в одностороннем порядке   прервать дополнительный розыгрыш и не разыгрывать и/или не выплачивать выигрыши, незамедлительно сообщив об этом через СМИ.</li>
<li>Все связанные с дополнительным розыгрышем споры разрешаются в соответствии с действующим законодательством Эстонской Республики. Все претензии, связанные с организацией и/или проведением дополнительного розыгрыша, следует отправлять в письменном виде по адресу Eesti Loto (см. п. 2 настоящих правил) не позднее 19.01.2024 года. Срок рассмотрения претензий составляет 2 недели с момента их поступления. Анонимные претензии и заявления не рассматриваются и остаются без ответа. </li>

    </ol>
  </>
);



export const rules_et_vikinglotto = (
  <>
  
  <p>
  <span className="accent">Klassikalise loterii Vikinglotto mängureeglid Eesti Vabariigis alates
						03.06.2021</span>{" "}
					Käesolevad reeglid kehtivad koos AS Eesti Loto (edaspidi Eesti Loto) klassikaliste loteriide{" "}
					<a className="clickableText clickableText--primary" href="https://www.eestiloto.ee/et/registration/rules" target="_blank" rel="noreferrer">üldreeglitega</a>.
          </p>
					<ol>
						<li>
							<h4>Mõisted</h4>
							<ul>
								<li><span>1.1.</span> <b>„Vikinglotto“</b> on klassikaline loterii, mida Eesti Loto
									korraldab koos partneritega Eesti Loto klassikaliste loteriide üldreeglites ja
									käesolevates mängureeglites sätestatud korras.</li>
								<li><span>1.2.</span> <b>„Mängukombinatsioon“</b> on Vikinglotto loosimisel osalev numbrite
									kogum, mis on valitud mängija või Eesti Loto infosüsteemi poolt (pliks-plaks) ja mis
									koosneb kuuest (6) põhinumbrist vahemikus üks kuni nelikümmend kaheksa (1-48) ning ühest
									(1) lisanumbrist vahemikus üks kuni viis (1-5).</li>
								<li><span>1.3.</span> <b>„Süsteemimäng”</b> on Vikinglotto loosimisel osalev
									mängukombinatsioonide kogum, mille moodustamiseks tuleb mängijal valida süsteemimängus
									osalevate põhi- ja lisanumbrite arv ja soovitud numbrid. Võimalusi põhi- ja lisanumbrite
									arvu valikuks koos vastava arvu põhi- ja lisanumbrite alusel moodustatavate
									mängukombinatsioonide koguarvuga väljendab järgnev tabel:</li>

								<table className="alt-table">
									<thead>
										<tr>
											<th></th>
											<th></th>
											<th colspan="5">Lisanumbreid</th>
										</tr>
                    </thead>
									<tbody>
										<tr>
											<td></td>
											<td></td>
											<td>1</td>
											<td>2</td>
											<td>3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>6</td>
											<td className="highlight">1*</td>
											<td className="highlight">2</td>
											<td className="highlight">3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>7</td>
											<td className="highlight">7</td>
											<td className="highlight">14</td>
											<td className="highlight">21</td>
											<td>28</td>
											<td>35</td>
										</tr>
										<tr>
											<td></td>
											<td>8</td>
											<td className="highlight">28</td>
											<td className="highlight">56</td>
											<td className="highlight">84</td>
											<td>112</td>
											<td>140</td>
										</tr>
										<tr>
											<td></td>
											<td>9</td>
											<td className="highlight">83</td>
											<td className="highlight">168</td>
											<td className="highlight">254</td>
											<td>336</td>
											<td>240</td>
										</tr>
										<tr>
											<td></td>
											<td>10</td>
											<td className="highlight">210</td>
											<td className="highlight">420</td>
											<td className="highlight">630</td>
											<td>840</td>
										</tr>
										<tr>
											<td></td>
											<td>11</td>
											<td>462</td>
											<td>924</td>
										</tr>
										<tr>
											<td></td>
											<td>12</td>
											<td>924</td>
										</tr>
									</tbody>
								</table>

								<span className="alt-content">*Kuuest (6) põhinumbrist ning ühest (1) lisanumbrist moodustatud
									mängukombinatsiooni ei loeta süsteemimänguks.</span>
								<li><span>1.4.</span> <b>„Mängulipik“</b> on vahend, mille abil saab mängija edastada Eesti
									Loto edasimüüjale kirjalikult loosimiste arvu või süsteemimängu valiku, soovitud
									mängukombinatsiooni(d) või pliks-plaks valiku. Vikinglotto mängulipikul saab mängija
									märkida kuni viis mängukombinatsiooni. Süsteemimängu numbreid saab märkida vaid
									mänguväljal A ning mängida saab kuni 10 põhinumbri ja kuni 3 lisanumbriga (mängulipikul
									valitavad kombinatsioonid on punktis 1.3 toodud tabelis tähistatud halliga).
								</li>
                <li><span>1.5.</span> <b>„Partner“</b> on Vikinglottot korraldav litsentseeritud
									loteriikorraldaja.</li>
								<li><span>1.6.</span> <b>„Mängupäev”</b> on võidunumbrite loosimise ja loosimise võitude
									selgumise päev, milleks on iga nädala kolmapäev. Partnerite ühisel otsusel võib
									mängupäeva erakorralistel juhtudel muuta.</li>
							</ul>
						</li>
						<li>
							<h4>Loosimisel osalemine</h4>
							<ul>
								<li><span>2.1.</span> Loosimisel osalemiseks teeb mängija pileti ostmisega panuse
									mängukombinatsioonile. Süsteemimängu korral teeb mängija panuse valitud hulga põhi- ja
									lisanumbritest moodustatud mängukombinatsioonidele.</li>
								<li><span>2.2.</span> Vikinglotto piletil võib olla üks (1) kuni kümme (10)
									mängukombinatsiooni või üks süsteemimäng.</li>
								<li><span>2.3.</span> Vikinglotto pileti saab osta korraga kuni kümneks loosimiseks.
									Mängulipikuga saab pileti osta üheks (1), kaheks (2), kolmeks (3), viieks (5) või
									kümneks (10) eelseisvaks järjestikuseks loosimiseks. Süsteemimängu saab mängulipikuga
									osta korraga üheks loosimiseks. Eesti Loto jätab endale õiguse piirata piletite
									etteostmise võimalust.</li>
								<li><span>2.4.</span> Ühe mängukombinatsiooni hind (panus) ühe loosimise kohta on 1,50 eurot
									ja pileti hind arvutatakse, korrutades hinna mängukombinatsioonide ja loosimiste arvuga.
								</li>
								<li><span>2.5.</span> Pileti saab osta:
									<ul>
										<li><span>2.5.1.</span> Eesti Loto edasimüüjate müügipunktidest, esitades müüjale
											täidetud mängulipiku, või teatades müüjale soovitud mängukombinatsiooni(d) ja
											loosimiste arvu.</li>
										<li><span>2.5.2.</span> interneti vahendusel Eesti Loto müügikeskkonnas;</li>
										<li><span>2.5.3.</span> mobiiltelefoni vahendusel, helistades numbrile 17788*2.</li>
									</ul>
								</li>
								<li><span>2.6.</span> Piletite müük konkreetsele loosimisele lõpetatakse selle loosimise
								mängupäeval kell 18.00 Kesk-Euroopa aja (CET) järgi (Eesti aja järgi kell 19.00).</li>
							</ul>
						</li>
						<li>
							<h4>Vikinglotto võidunumbrite loosimine</h4>
							<ul>
								<li><span>3.1.</span> Vikinglotto loosimine toimub igal mängupäeval kell 19.00 Kesk-Euroopa
									aja (CET) järgi (Eesti aja järgi kell 20.00). Vikinglotto loosimise viib läbi Norsk
									Tipping A/S, asukohaga Hamar, Norra.</li>
								<li><span>3.2.</span> Loosimisel kasutatakse kahte lototroni. Esimeses lototronis
									kasutatakse pallikomplekti numbritega ühest (1) neljakümne kaheksani (48), teises
									lototronis kasutatakse pallikomplekti ühest (1) viieni (5).</li>
								<li><span>3.3.</span> Loosimise käigus loositakse:
									<ul>
										<li><span>3.3.1.</span> esmalt esimese lototroniga kuus (6) põhinumbrit vahemikus
											üks (1) kuni nelikümmend kaheksa (48);</li>
										<li><span>3.3.2.</span> seejärel teise lototroniga üks (1) lisanumber vahemikus üks
											(1) kuni viis (5).</li>
									</ul>
								</li>
							</ul>
						</li>
						<li>
						
					
              <h4>Vikinglotto lisavõidud ja miljoniloos</h4>
              <ul>
<li><span>4.1.</span>    Vikinglotto lisavõitudena loositakse igal kolmapäeval kõigi sama nädala loosimisel osalevate mängukombinatsioonide vahel välja 1 x 10 000 eurot. 
</li><li><span>4.2. </span>   Miljoniloosina loositakse iga aasta jaanuaris kõigi eelneval aastal ostetud mängukombinatsioonide vahel välja 1 000 000 eurot. 2023.a jaanuaris toimuval loosimisel osalevad kõik mängukombinatsioonid, mis on ostetud vahemikus 01.01.2023-31.12.2023. Miljon eurot läheb jagamisele 1 kuni 5 mängukombinatsiooni vahel. Vastav jagaja loositakse välja enne miljoniloosi võitja(te) loosimist. 
</li><li><span>4.3.</span>    Lisavõitude ja Miljoniloosi võitja(te) loosimisel kasutatakse juhuarvu generaatorit. Miljoniloosi jagaja loosimisel kasutatakse pallikomplekti numbritega ühest (1) viieni (5).
</li><li><span>4.4.</span>    Vikinglotto lisavõidud ja Miljoniloos makstakse välja Eesti Loto reservfondist.
</li><li><span>4.5.</span>    Iganädalane lisaloos viiakse läbi Eesti Loto kontoris, aadressil Hallivanamehe 4, Tallinn. Miljoniloosi loosimine viiakse läbi telestuudios.
          </li></ul>
          
          
          
          	</li>
						<li>
							<h4>Võidud, võidufond ja selle jaotus</h4>
							<ul>
								<li><span>5.1.</span> Võidud jagunevad võidutasanditesse olenevalt loositud numbritega kokku
									langevate mängukombinatsiooni numbrite arvust. Võidutasandid on nummerdatud alates
									esimesest (I) võidutasandist, mis on kõrgeim võidutasand (kõige enam loositud numbritega
									kokkulangevaid numbreid), kuni üheksanda (IX) võidutasandini, mis on madalaim (kõige
									vähem loositud numbritega kokkulangevaid numbreid).</li>
								<li><span>5.2</span> Vikinglotto võidutasandid on järgmised:
									<table className="table-half">
										<tr>
											<th>Võidutasand</th>
											<th>Loositud numbritega kokkulangevad numbrid</th>
										</tr>
										<tr>
											<td>I</td>
											<td>6 põhinumbrit</td>
										</tr>
										<tr>
											<td>II</td>
											<td>6 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>III</td>
											<td>5 põhinumbrit</td>
										</tr>
										<tr>
											<td>IV</td>
											<td>5 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>V</td>
											<td>4 põhinumbrit</td>
										</tr>
										<tr>
											<td>VI</td>
											<td>4 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>VII</td>
											<td>3 põhinumbrit</td>
										</tr>
										<tr>
											<td>VIII</td>
											<td>3 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>IX</td>
											<td>2 põhinumbrit + 1 lisanumber</td>
										</tr>
									</table>
								</li>
								<li><span>5.3.</span> Vikinglotto võidufondi arvatakse igal loosimisel 50% kõikide mängijate
									poolt konkreetseks loosimiseks tehtud panustest.</li>
								<li><span>5.4.</span> Võidufond jaguneb järgmiselt:
									<ul>
										<li><span>5.4.1.</span> Vikinglotto I võidutasandi (jackpot’i) võidufondiks, kuhu
											kantakse igast panusest null koma kolmteist (0,13) eurot;</li>
										<li><span>5.4.2.</span> Vikinglotto II võidutasandi võidufondiks, kuhu kantakse
											igast panusest null koma null kolmteist (0,013) eurot;.</li>
										<li><span>5.4.3.</span> Vikinglotto ühiseks reservfondiks, kuhu kantakse igast
											panusest null koma null nelikümmend kaks (0,042) eurot.</li>
										<li><span>5.4.4.</span> Eesti Loto omavõidufondiks, mille moodustab ülejäänud osa
											võidufondist ja mis jaguneb III kuni IX võidutasandi ja Eesti Loto reservfondi
											vahel järgmiselt:
											<table className="table-half remove-margin">
												<tr>
													<th>Võidu tasand</th>
													<th>Osakaal omavõidufondist</th>
												</tr>
												<tr>
													<td>III</td>
													<td>16 %</td>
												</tr>
												<tr>
													<td>IV</td>
													<td>7,5 %</td>
												</tr>
												<tr>
													<td>V</td>
													<td>11 %</td>
												</tr>
												<tr>
													<td>VI</td>
													<td>8.5 %</td>
												</tr>
												<tr>
													<td>VII</td>
													<td>8.5 %</td>
												</tr>
												<tr>
													<td>VIII</td>
													<td>12.5 %</td>
												</tr>
                        <tr>
												<td>IX</td>
												<td>7.5 %</td>
												</tr>
												<tr>
													<td>Eesti Loto reservfond</td>
													<td>28.5 %</td>
												</tr>
											</table>
										</li>
									</ul>
								</li>
								<li><span>5.5.</span> Vikinglotto I ja II võidutasandi võidufondid ja Vikinglotto reservfond
									on partneritega ühised, ülejäänud võidufondid moodustuvad vaid Eestis müüdud
									mängukombinatsioonide põhiselt.</li>
								<li><span>5.6.</span> I võidutasandi võidufond koosneb:
									<ul>
										<li><span>5.6.1.</span> kõigi partnerite poolt selleks konkreetseks loosimiseks
											müüdud mängukombinatsioonide koguarvust korrutatuna null koma kolmeteistkümne
											(0,13) euroga;</li>
										<li><span>5.6.2.</span> eelmistest loosimistest vastavalt mängureeglite punktile
											5.12 edasi kandunud I võidutasandi võidufondist;</li>
										<li><span>5.6.3.</span> Vikinglotto ühise reservfondi limiiti ületavast summast
											vastavalt p. 5.10;</li>
										<li><span>5.6.4.</span> II võidutasandi võidufondi limiiti ületavast summast p. 5.9
											nimetatud juhul.</li>
									</ul>
								</li>
								<li><span>5.7.</span> I võidutasandi võidufondile on kehtestatud minimaalne suurus 3 000 000
									(kolm miljonit) eurot ja maksimaalne suurus 25 000 000 (kakskümmend viis miljonit)
									eurot. Võidufondi minimaalne suurus garanteeritakse Vikinglotto ühisest reservfondist.
									Juhul kui I võidutasandi võidufond ületab võidufondi maksimaalse suuruse, lisatakse üle
									jääv summa sama loosimise II võidutasandi võidufondile.</li>
								<li><span>5.8.</span> II võidutasandi võidufond koosneb:
									<ul>
										<li><span>5.8.1.</span> kõigi partnerite poolt selleks konkreetseks loosimiseks
											müüdud mängukombinatsioonide koguarvust korrutatuna null koma null
											kolmeteistkümne (0,013) euroga;</li>
										<li><span>5.8.2.</span> eelmistest loosimistest vastavalt mängureeglite punktile
											5.12. edasi kandunud II võidutasandi võidufondist;</li>
										<li><span>5.8.3.</span> I võidutasandi võidufondi limiiti ületavast summast
											vastavalt p. 5.7.</li>
									</ul>
								</li>
								<li><span>5.9.</span> II võidutasandi võidufondile on kehtestatud maksimaalne suurus 25 000
									000 (kakskümmend viis miljonit) eurot. Juhul kui II võidutasandi võidufond ületab
									võidufondi maksimaalse suuruse, lisatakse üle jääv summa järgmise loosimise I
									võidutasandi võidufondile.</li>
								<li><span>5.10.</span> Vikinglotto ühisele reservfondile on kehtestatud maksimaalne suurus
									20 000 000 (kakskümmend miljonit) eurot. Juhul kui Vikinglotto ühise reservfondi suurus
									ületab maksimaalse suuruse, lisatakse üle jääv summa järgmise loosimise I võidutasandi
									võidufondile.</li>
								<li><span>5.11.</span> Võidutasandi võitja(te)ks on mängija(d), kes on saanud võidutasandile
									vastava tabamuse. Võidutasandi võidu suurus saadakse vastava võidutasandi võidufondi
									jagamisel vastava võidutasandi võitjate arvuga.</li>
								<li><span>5.12.</span> Võidu puudumise korral konkreetsel võidutasandil lisatakse selle
									võidutasandi võidufond järgmise loosimise sama võidutasandi võidufondile. Protseduuri
									jätkatakse loosimisest loosimiseni kuni vastava võidutasandi võidu (võitude)
									väljaloosimiseni.</li>
								<li><span>5.13.</span> Ühe mängukombinatsiooniga on võimalik saada ühel loosimisel vaid üks
									võit. Kui mängija mängukombinatsioon vastab erinevate võidutasandite tabamustele, siis
									loetakse võiduks kõrgeima võidutasandi võit. </li>
								<li><span>5.14.</span> Eesti Loto poolt müüdud Vikinglotto mängukombinatsiooniga saadud
									võidu minimaalne suurus on üks euro ja viiskümmend senti (1,50 €). Juhul kui võidu
									arvestuslik suurus on alla ühe euro ja viiekümne sendi (1,50 €), katab Eesti Loto
									puuduoleva summa Eesti Loto reservfondist.</li>
								<li><span>5.15.</span> Kõik I ja II võidutasandi võidud ümardatakse kümne (10) sendi
									täpsusega allapoole ning võit makstakse välja vastavalt ümardatud suurusele. Ümardustest
									tekkiv vahe arvatakse Vikinglotto ühisesse reservfondi.</li>
								<li><span>5.16.</span> Kõik III- IX võidutasandi võidud ümardatakse kümne (10) sendi
									täpsusega allapoole ning võit makstakse välja vastavalt ümardatud suurusele. Ümardustest
									tekkiv vahe arvatakse Eesti Loto reservfondi.</li>
								<li><span>5.17.</span> Kõik I ja II võidutasandi vormistamata võidud suuruses 3 000 000
									(kolm miljonit) eurot või üle selle kantakse Vikinglotto ühisesse reservfondi. Väiksemad
									vormistamata võidud arvatakse Eesti Loto reservfondi.</li>
								<li><span>5.18.</span> Eesti Loto edasimüüjad maksavad võidunõuded välja ainult Eesti Loto
									edasimüüjate poolt väljastatud ja müüdud piletite alusel. Eesti Loto ei maksa võidunõuet
									välja pileti alusel, mis on ostetud mõne teise partneri vahendusel.</li>
							</ul>
						</li>
					</ol>
  



  </>);




export const rules_ru_vikinglotto = (
  <>
  	<p>
      <span className="accent">Правила игры в классическую лотерею Vikinglotto в Эстонской Республике с 03.06.2021</span>{" "}
					Настоящие правила действуют вместе с {" "}
          <a href="https://www.eestiloto.ee/ru/registration/rules" target="_blank" rel="noreferrer" >общими правилами</a> {" "}
          классических лотерей AS Eesti Loto (в дальнейшем Eesti Loto).</p>
		
        	<ol>
						<li>
							<h4>ПОНЯТИЯ</h4>
							<ul>
								<li><span>1.1.</span> <b>„Vikinglotto“</b> классическая лотерея, которую Eesti Loto организует совместно с партнерами
								в соответствии с порядком, установленным общими правилами классических лотерей Eesti Loto и настоящими правилами игры.</li>
								<li><span>1.2.</span> <b>„Игровая комбинация“</b> участвующая в розыгрыше Vikinglotto совокупность номеров, выбранная 
								игроком или инфосистемой Eesti Loto (pliks-plaks), которая состоит из шести (6) основных номеров в промежутке от одного
								до сорока восьми (1-48) и одного (1) дополнительного номера в промежутке от одного до пяти (1-5).</li>
								<li><span>1.3.</span> <b>„Системная игра”</b> участвующая в розыгрыше Vikinglotto совокупность игровых комбинаций, для 
								образования которой игроку необходимо выбрать количечтво основных- и дополнительных номеров системной игры. 
								Возможности выбора основных и дополнительных номеров вместе с общим количеством создавемых ими игровых комбинаций 
								иллюстрирует приведённая ниже таблица:</li>

								<table className="alt-table">
									<thead>
										<tr>
											<th></th>
											<th></th>
											<th colspan="5">Дополнительные номера</th>
										</tr>
                    </thead>
									<tbody>
										<tr>
											<td></td>
											<td></td>
											<td>1</td>
											<td>2</td>
											<td>3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>6</td>
											<td className="highlight">1*</td>
											<td className="highlight">2</td>
											<td className="highlight">3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>7</td>
											<td className="highlight">7</td>
											<td className="highlight">14</td>
											<td className="highlight">21</td>
											<td>28</td>
											<td>35</td>
										</tr>
										<tr>
											<td></td>
											<td>8</td>
											<td className="highlight">28</td>
											<td className="highlight">56</td>
											<td className="highlight">84</td>
											<td>112</td>
											<td>140</td>
										</tr>
										<tr>
											<td></td>
											<td>9</td>
											<td className="highlight">83</td>
											<td className="highlight">168</td>
											<td className="highlight">254</td>
											<td>336</td>
											<td>240</td>
										</tr>
										<tr>
											<td></td>
											<td>10</td>
											<td className="highlight">210</td>
											<td className="highlight">420</td>
											<td className="highlight">630</td>
											<td>840</td>
										</tr>
										<tr>
											<td></td>
											<td>11</td>
											<td>462</td>
											<td>924</td>
										</tr>
										<tr>
											<td></td>
											<td>12</td>
											<td>924</td>
										</tr>
									</tbody>
								</table>

								<span className="alt-content">*Игровая комбинация, образованная из шести (6) основных номеров и одного (1) 	
								дополнительного номера, не является системной игрой.</span>
								<li><span>1.4.</span> <b>„Игровой купон“</b> средство, с помощью которого игрок может передать торговому 
								дистрибьютеру Eesti Loto в письменном виде выбранную им игровую комбинацию (-ии) и количество розыгрышей 
								или номера системной игры или выбор pliks-plaks. На игровом купоне Vikinglotto игрок может выбрать до 
								пяти игровых комбинаций. Номера системной игры можно отметить только на игровом поле А и сыграть можно 
								используя до 10 основных номеров и до 3 дополнительных номеров (выбираемые на игровом купоне комбинации 
								отмечены серым фоном в приведённой в пункте 1.3 таблице).</li>
								<li><span>1.5.</span> <b>„Партнер“</b> лицензированный организатор лотереи Vikinglotto.</li>
								<li><span>1.6.</span> <b>„Игровой день”</b> день, когда разыгрываются выигрышные номера и определяются 
								выигрыши розыгрыша; этим днем является каждая среда. По общему решению партнеров игровой день в 
								исключительных случаях может быть изменен.</li>
							</ul>
						</li>
						<li>
							<h4>УЧАСТИЕ В РОЗЫГРЫШЕ</h4>
							<ul>
								<li><span>2.1.</span> Для участия в розыгрыше игрок покупкой билета делает ставку на игровую комбинацию. 
								В случае системной игры игрок делает ставку на игровые комбинации, образованные из выбранного количества 
								основных и дополнительных номеров.</li>
								<li><span>2.2.</span> На билете Vikinglotto может быть отмечено от одной (1) до десяти (10) игровых 
								комбинаций или одна системная игра.</li>
								<li><span>2.3.</span> Билет Vikinglotto можно купить максимально на десять (10) розыгрышей. С игровым 
								купоном можно купить билет на один (1), два (2), три (3), пять (5) или десять (10) следующих друг за другом 
								еженедельных розыгрышей. Системную игру можно купить с игровым купоном только на один розыгрыш одновременно. 
								Eesti Loto оставляет за собой право ограничивать возможность покупки билетов cразу на несколько розыгрышей.</li>
								<li><span>2.4.</span> Цена одной игровой комбинации (ставка) на один розыгрыш составляет один евро и пятьдесят 
								евроцентов (1,50 €); стоимость билета рассчитывается путем перемножения ставки, количества игровых комбинаций 
								и количества розыгрышей.
								</li>
								<li><span>2.5.</span> Билет можно купить:
									<ul>
										<li><span>2.5.1.</span> в пунктах продажи дистрибьюторов Eesti Loto, представив продавцу заполненный 
										игровой купон или сообщив продавцу о желаемых игровых комбинациях и количество розыгрышей;</li>
										<li><span>2.5.2.</span> через интернет на сайте Eesti Loto;</li>
										<li><span>2.5.3.</span> по мобильному телефону, позвонив по номеру 17788*2.</li>
										</ul>
								</li>
								<li><span>2.6.</span> Продажа билетов на конкретный розыгрыш заканчивается в соответствующий игровой день в 18:00 по центральноевропейскому времени (CET) 
						(в 19:00 по эстонскому времени).						</li>
							</ul>
						</li>
						<li>
							<h4>РОЗЫГРЫШ ВЫИГРЫШНЫХ НОМЕРОВ VIKINGLOTTO</h4>
							<ul>
								<li><span>3.1.</span> Розыгрыш Vikinglotto проводится каждый игровой день в 19:00 по центральноевропейскому времени (CET) 
								(в 20:00 по эстонскому времени). Розыгрыш Vikinglotto проводит Norsk Tipping A/S, местонахождение Хамар, Норвегия.</li>
								<li><span>3.2.</span> При проведении розыгрыша используются два лототрона. В первом лототроне используется комплект шаров 
								с номерами от одного (1) до сорока восьми (48), во втором лототроне – комплект шаров с номерами от одного (1) до пяти (5).</li>
								<li><span>3.3.</span> В ходе розыгрыша разыгрываются:
									<ul>
										<li><span>3.3.1.</span> сначала в первом лототроне шесть (6) основных номеров из диапазона от одного (1) до сорока восьми (48);</li>
										<li><span>3.3.2.</span> затем во втором лототроне один (1) дополнительный номер из диапазона от одного (1) до пяти (5).</li>
									</ul>
								</li>
							</ul>
						</li>
						<li>


							


              <h4>ДОПОЛНИТЕЛЬНЫЕ ВЫИГРЫШИ VIKINGLOTTO И РОЗЫГРЫШ МИЛЛИОНА </h4>
              <ul>
								<li><span>4.1.</span>    В качестве доплнительных выигрышей Vikinglotto каждую среду между всеми игровыми комбинациями, принимающих участие в розыгрыше этой недели, разыгрывается 1 х 10 000 евро.
</li><li><span>4.2.</span>    Розыгрыш Миллионна проводится ежегодно в январе и между всеми игровыми комбинациями, купленными в прошлом году, разыгрывается 1 000 000 евро. В проводимом в январе 2023 года примут участие все игровые комбинации, купленные в период времени с 01.01.2023 по 31.12.2023. Миллион евро будет разделён между 1-5 игровыми комбинациями. Соответствующий делитель будет определён в ходе розыгрыша непосредственно перед розыгрышом победителей Розыгрыша Миллион
</li><li><span>4.3.</span>    Для розыгрыша дополнительных выигрышей и Розыгрыша Миллиона используется генератор случайных чисел. Для розыгрыша делителя Розыгрыша Миллиона используется комплект шаров с номерами от одного (1) до пяти (5).
</li><li><span>4.4.</span>    Доплнительные выигрыши Vikinglotto и выигрыш Розыгрыша Миллиона выплачивают из резервного фонда Eesti Loto.
</li><li><span>4.5.</span>    Еженендельный дополнительный розыгрыш проводится в офисе Eesti Loto по адресу Халливанамехе 4. Розыгрыш Миллиона проводится в телестудии.
</li></ul>



						</li>
						<li>
							<h4>ВЫИГРЫШИ, ПРИЗОВОЙ ФОНД И ЕГО РАСПРЕДЕЛЕНИЕ  </h4>
							<ul>
								<li><span>5.1.</span> Выигрыши распределяются по призовым уровням в зависимости от количества номеров в 
								игровой комбинации, совпавших с разыгранными номерами. Призовые уровни пронумерованы от первого (I) 
								призового уровня, который является высшим призовым уровнем (больше всего номеров, совпавших с 
								разыгранными номерами), до дечвятого (IX) призового уровня, который является низшим призовым 
								уровнем (меньше всего номеров, совпавших с разыгранными номерами).</li>
								<li><span>5.2</span> Призовые уровни игры:
									<table className="table-half">
										<tr>
											<th>Призовой уровень</th>
											<th>Количество совпавших номеров</th>
										</tr>
										<tr>
											<td>I</td>
											<td>6 основных номеров + 1 дополнительный номер</td>
										</tr>
										<tr>
											<td>II</td>
											<td>6 основных номеров</td>
										</tr>
										<tr>
											<td>III</td>
											<td>5 основных номеров + 1 дополнительный номер</td>
										</tr>
										<tr>
											<td>IV</td>
											<td>5 основных номеров</td>
										</tr>
										<tr>
											<td>V</td>
											<td>4 основных номера + 1 дополнительный номер</td>
										</tr>
										<tr>
											<td>VI</td>
											<td>4 основных номера</td>
										</tr>
										<tr>
											<td>VII</td>
											<td>3 основных номера + 1 дополнительный номер</td>
										</tr>
										<tr>
											<td>VIII</td>
											<td>3 основных номера</td>
										</tr>
										<tr>
											<td>IX</td>
											<td>2 основных номера и 1 дополнительный номер</td>
										</tr>
									</table>
								</li>
								<li><span>5.3.</span> В призовой фонд Vikinglotto при каждом розыгрыше перечисляется 50 % общей суммы ставок, 
								сделанных всеми игроками к конкретному розыгрышу.</li>
								<li><span>5.4.</span> Призовой фонд распределяется между:
									<ul>
										<li><span>5.4.1.</span> призовым фондом I призового уровня (джекпот) Vikinglotto, в который 
										перечисляется ноль запятая тринадцать (0,13) евро с каждой ставки;</li>
										<li><span>5.4.2.</span> призовым фондом II призового уровня Vikinglotto, в который перечисляется 
										ноль запятая ноль тринадцать (0,013) евро с каждой ставки;</li>
										<li><span>5.4.3.</span> единым резервным фондом Vikinglotto, в который перечисляется ноль 
										запятая ноль сорок два (0,042) евро с каждой ставки;</li>
										<li><span>5.4.4.</span> собственным призовым фондом Eesti Loto, который образуется из 
										остальной части призового фонда и который распределяется между III-IX призовыми 
										уровнями и резервным фондом Eesti Loto следующим образом:
											<table className="table-half remove-margin">
												<tr>
													<th>Призовой уровень</th>
													<th>Доля собственного призового фонда</th>
												</tr>
												<tr>
													<td>III</td>
													<td>16 %</td>
												</tr>
												<tr>
													<td>IV</td>
													<td>7,5 %</td>
												</tr>
												<tr>
													<td>V</td>
													<td>11 %</td>
												</tr>
												<tr>
													<td>VI</td>
													<td>8.5 %</td>
												</tr>
												<tr>
													<td>VII</td>
													<td>8.5 %</td>
												</tr>
												<tr>
													<td>VIII</td>
													<td>12.5 %</td>
												</tr>
                        <tr>
												<td>IX</td>
												<td>7.5 %</td>
												</tr>
												<tr>
													<td>Резервный фонд Eesti Loto</td>
													<td>28.5 %</td>
												</tr>
											</table>
										</li>
									</ul>
								</li>
								<li><span>5.5.</span> В Vikinglotto призовые фонды I и II призового уровня у 
								всех партнеров являются едиными; призовые фонды более низких призовых уровней 
								формируются только за счет проданных в Эстонии игровых комбинаций.</li>
								<li><span>5.6.</span> Призовой фонд I призового уровня состоит из:
									<ul>
										<li><span>5.6.1.</span> общего количества игровых комбинаций, проданных всеми партнерами к 
										конкретному розыгрышу, умноженного на ноль запятая тринадцать (0,13) евро;</li>
										<li><span>5.6.2.</span> призового фонда I призового уровня, перешедшего с 
										предыдущих розыгрышей в соответствии с пунктом 5.12. правил игры;</li>
										<li><span>5.6.3.</span> суммы, превышающей лимит единого резервного фонда 
										Vikinglotto, в соответствии с пунктом 5.10. правил игры;</li>
										<li><span>5.6.4.</span> суммы, превышающей лимит призового фонда II 
										призового уровня, в соответствии с пунктом 5.9. правил игры.</li>
									</ul>
								</li>
								<li><span>5.7.</span> Для призового фонда I призового уровня установлен минимальный 
								размер 3 000 000 (три миллиона) евро и максимальный размер 25 000 000 
								(двадцать пять миллионов) евро. Минимальный размер призового фонда гарантируется 
								единым резервным фондом Vikinglotto. Если призовой фонд I призового уровня превышает 
								максимальный размер призового фонда, превышающая максимальный размер сумма прибавляется 
								к призовому фонду II призового уровня того же розыгрыша.</li>
								<li><span>5.8.</span> Призовой фонд II призового уровня состоит из:
									<ul>
										<li><span>5.8.1.</span> общего количества игровых комбинаций, проданных всеми партнерами 
										к конкретному розыгрышу, умноженного на ноль запятая ноль тринадцать (0,013) евро;</li>
										<li><span>5.8.2.</span> призового фонда II призового уровня, перешедшего с предыдущих 
										розыгрышей в соответствии с пунктом 5.12. правил игры;</li>
										<li><span>5.8.3.</span> суммы, превышающей лимит призового фонда I призового 
										уровня, в соответствии с пунктом 5.7. правил игры.</li>
									</ul>
								</li>
								<li><span>5.9.</span> Для призового фонда II призового уровня установлен максимальный 
								размер 25 000 000 (двадцать пять миллионов) евро. Если призовой фонд II призового 
								уровня превышает максимальный размер призового фонда, превышающая максимальный 
								размер сумма прибавляется к призовому фонду I призового уровня следующего розыгрыша.</li>
								<li><span>5.10.</span> Для единого резервного фонда Vikinglotto установлен максимальный 
								размер 20 000 000 (двадцать миллионов) евро. Если размер единого резервного фонда 
								Vikinglotto превышает максимальный размер, превышающая максимальный размер сумма 
								прибавляется к призовому фонду I призового уровня следующего розыгрыша.</li>
								<li><span>5.11.</span> Победителем(ями) призового уровня станови(я)тся игрок(и), 
								у которого(ых) количество совпавших номеров в игровой комбинации соответствует призовому уровню.
								Размер выигрыша призового уровня рассчитывается путем деления призового фонда соответствующего 
								призового уровня на количество победителей на данном призовом уровне.</li>
								<li><span>5.12.</span> В случае отсутствия на конкретном призовом уровне хотя бы 
								одного победителя призовой фонд данного призового уровня прибавляется к призовому фонду этого же призового 
								уровня следующего розыгрыша. Процедура повторяется от розыгрыша к розыгрышу до тех пор, пока на 
								соответствующем призовом уровне не появится хотя бы один победитель.</li>
								<li><span>5.13.</span> С одной игровой комбинацией в одном розыгрыше можно получить только один выигрыш. 
								Если количество совпавших номеров в игровой комбинации игрока соответствует нескольким призовым уровням, 
								то выигрышем считается выигрыш наиболее высокого уровня.</li>
								<li><span>5.14.</span> Минимальный размер единичного выигрыша по проданной Eesti Loto игровой комбинации 
								Vikinglotto составляет один евро и пятьдесят евроцентов (1,50 €). Если размер рассчитываемого единичного 
								выигрыша составляет меньше одного евро и пятидесяти евроцентов (1,50 €), Eesti Loto покрывает недостающую 
								сумму за счет резервного фонда Eesti Loto.</li>
								<li><span>5.15.</span> Все выигрыши I и II призового уровня округляются с точностью до десяти (10) центов 
								в меньшую сторону; выигрыш выплачивается соответственно округленной сумме. Остаток, получаемый при округлении,
								перечисляется в единый резервный фонд Vikinglotto.</li>
								<li><span>5.16.</span> Все выигрыши III-VIII призового уровня округляются с точностью до десяти (10) центов в 
								меньшую сторону; выигрыш выплачивается соответственно округленной сумме. Остаток, получаемый при округлении, 
								перечисляется в резервный фонд Eesti Loto.</li>
								<li><span>5.17.</span> Все невостребованные выигрыши в размере 3 миллионов (3 000 000) евро или больше 
								перечисляются в единый резервный фонд Vikinglotto. Невостребованные выигрыши меньшего размера 
								перечисляются в резервный фонд Eesti Loto.</li>
								<li><span>5.18.</span> Дистрибьюторы Eesti Loto удовлетворяют требования выигрыша только на основании 
								билетов, выданных и проданных дистрибьюторами Eesti Loto. Eesti Loto не удовлетворяет требования выигрыша 
								на основании билетов, купленных через какого-либо другого партнера.</li>
							</ul>
						</li>
					</ol>
  



  </>);